'use strict';

exports.__esModule = true;
exports.typeSets = exports.Elements = exports.applyType = exports.applyRhythm = exports.generateHeadingType = exports.generateParagraphType = exports.Type = undefined;

var _jwe4azv = require('./typeSets/jwe4azv.js');

var _jwe4azv2 = _interopRequireDefault(_jwe4azv);

var _ltb1ekq = require('./typeSets/ltb1ekq.js');

var _ltb1ekq2 = _interopRequireDefault(_ltb1ekq);

var _ppv6ieb = require('./typeSets/ppv6ieb.js');

var _ppv6ieb2 = _interopRequireDefault(_ppv6ieb);

var _dkc2ilk = require('./typeSets/dkc2ilk.js');

var _dkc2ilk2 = _interopRequireDefault(_dkc2ilk);

var _H = require('./elements/H1');

var _H2 = _interopRequireDefault(_H);

var _H3 = require('./elements/H2');

var _H4 = _interopRequireDefault(_H3);

var _H5 = require('./elements/H3');

var _H6 = _interopRequireDefault(_H5);

var _H7 = require('./elements/H4');

var _H8 = _interopRequireDefault(_H7);

var _H9 = require('./elements/H5');

var _H10 = _interopRequireDefault(_H9);

var _H11 = require('./elements/H6');

var _H12 = _interopRequireDefault(_H11);

var _Paragraph = require('./elements/Paragraph');

var _Paragraph2 = _interopRequireDefault(_Paragraph);

var _Ul = require('./elements/Ul');

var _Ul2 = _interopRequireDefault(_Ul);

var _Ol = require('./elements/Ol');

var _Ol2 = _interopRequireDefault(_Ol);

var _Type2 = require('./Type.js');

var _Type3 = _interopRequireDefault(_Type2);

var _paragraphs = require('./typeDefs/paragraphs.js');

var _paragraphs2 = _interopRequireDefault(_paragraphs);

var _headings = require('./typeDefs/headings.js');

var _headings2 = _interopRequireDefault(_headings);

var _applyRhythm2 = require('./typeDefs/applyRhythm.js');

var _applyRhythm3 = _interopRequireDefault(_applyRhythm2);

var _applyType2 = require('./typeDefs/applyType.js');

var _applyType3 = _interopRequireDefault(_applyType2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** Elements */
// ------------------------------------------------------------------------------
// ---------------------------------------------------------------------- Imports
// ------------------------------------------------------------------------------
/** Kits */
exports.Type = _Type3.default;

// ------------------------------------------------------------------------------
// ----------------------------------------------------------------------- Export
// ------------------------------------------------------------------------------

exports.generateParagraphType = _paragraphs2.default;
exports.generateHeadingType = _headings2.default;
exports.applyRhythm = _applyRhythm3.default;
exports.applyType = _applyType3.default;
var Elements = exports.Elements = {
  H1: _H2.default,
  H2: _H4.default,
  H3: _H6.default,
  H4: _H8.default,
  H5: _H10.default,
  H6: _H12.default,
  Paragraph: _Paragraph2.default,
  Ul: _Ul2.default,
  Ol: _Ol2.default
};

var typeSets = exports.typeSets = {
  jwe4azv: _jwe4azv2.default,
  ltb1ekq: _ltb1ekq2.default,
  ppv6ieb: _ppv6ieb2.default,
  dkc2ilk: _dkc2ilk2.default
};


//////////////////
// WEBPACK FOOTER
// ./~/@bodhi-project/typography/lib/index.js
// module id = 13
// module chunks = 168707334958949